import { render, staticRenderFns } from "./CodifiersRating.vue?vue&type=template&id=6686d204&scoped=true&"
import script from "./CodifiersRating.vue?vue&type=script&lang=js&"
export * from "./CodifiersRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6686d204",
  null
  
)

export default component.exports